"use strict";

angular.module("licensure.services").factory("EnterpriseLinkService", [
    "$http",
    "$q",
    function ($http, $q) {
        return {
            get: function () {
                var d = $q.defer();

                $http.get(apiLocation + '/api/EntityEnterpriseLink', {
                    params: {

                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getLink: function (id) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/EntityEnterpriseLink/' + id, {
                        params: {
                        }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },
        };
    }
]);
